import React, { useState } from "react";
import './Sub&Gal.css';
import Gallary from '../PhotoGal/PhotoGal';
import Sectors from "../sectors/sectors";

function SubGal() {
    const [activeTab, setActiveTab] = useState('sectors'); // Default to 'sectors'

    return (
        <div className='SubGal-container'>
            <nav>
                <span 
                    onClick={() => setActiveTab('sectors')} 
                    className={activeTab === 'sectors' ? 'active' : ''}
                >
                    المشاركين
                </span>
                <span 
                    onClick={() => setActiveTab('gallary')} 
                    className={activeTab === 'gallary' ? 'active' : ''}
                >
                    معرض الصور
                </span>
            </nav>
            {activeTab === 'sectors' && <Sectors className="Sectors1" />}
            {activeTab === 'gallary' && <Gallary className="Gallary1" />}
        </div>
    );
}

export default SubGal;
